import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { Logo } from "../ui/Logo";
import { ThemeToggle } from "../ui/ThemeToggle";
import { BrutalButton } from "../ui/BrutalButton";
import { IconButton } from "../ui/IconButton";
import { SiteFooter } from "./SiteFooter";
import { spring } from "../../utils/motion";
const links = [{
  to: "/pricing",
  label: "Pricing"
}, {
  to: "/about",
  label: "About"
}, {
  to: "/faq",
  label: "FAQ"
}, {
  to: "/contact",
  label: "Contact"
}];
export function PublicLayout() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  const reduce = useReducedMotion() ?? false;
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <div className="pat-dots flex min-h-screen w-full flex-col bg-paper font-sans text-ink" data-id="element-521" data-mp="1bayy661m2018">
      <header className="sticky top-0 z-40 border-b-3 border-line bg-paper/90 backdrop-blur-md" data-id="element-522" data-mp="114izstapwjdw">
        <div className="mx-auto flex h-[68px] max-w-6xl items-center justify-between gap-4 px-5 md:px-8" data-id="element-523" data-mp="1633ygoabmv08">
          <Logo data-id="element-524" data-mp="reze7fvmebfc" />
          <nav aria-label="Main" className="hidden items-center gap-1 md:flex" data-id="element-525" data-mp="rdfybqdvm2e3">
            {links.map(l => <NavLink key={l.to} to={l.to} className={({
            isActive
          }) => `focus-ring relative rounded-xl px-3.5 py-2 text-sm font-semibold transition-colors duration-150 ${isActive ? "text-ink" : "text-ink-2 hover:text-ink"}`} data-id="element-526" data-mp="wc9b1glc9pd7">
                {({
              isActive
            }) => <>
                    {isActive && <motion.span layoutId="public-nav" transition={spring.snappy} className="absolute inset-0 rounded-xl border-2 border-line bg-brand-tint" aria-hidden="true" data-id="element-527" data-mp="22t4mum6s39h0" />}
                    <span className="relative" data-id="element-528" data-mp="21bfn5ipzoagm">{l.label}</span>
                  </>}
              </NavLink>)}
          </nav>
          <div className="flex items-center gap-2.5" data-id="element-529" data-mp="1wf7d2jqnf7gb">
            <ThemeToggle data-id="element-530" data-mp="1rfl0mcin9v8k" />
            <Link to="/auth/signin" className="focus-ring hidden rounded-xl px-3 py-2 text-sm font-semibold text-ink-2 hover:text-ink sm:block" data-id="element-531" data-mp="1rge0ctj6rkh7">
              Sign in
            </Link>
            <span className="hidden sm:block" data-id="element-532" data-mp="2fc8ig5o479ks">
              <BrutalButton to="/auth/signup" size="sm" data-id="element-533" data-mp="2faxfg82hu5uq">
                Start free
              </BrutalButton>
            </span>
            <span className="md:hidden" data-id="element-534" data-mp="2abb5c7hyp5q5">
              <IconButton label={open ? "Close menu" : "Open menu"} onClick={() => setOpen(o => !o)} data-id="element-535" data-mp="37st1u3slj71b">
                {open ? <XIcon className="h-5 w-5" data-id="element-536" data-mp="330rsapmtbuez" /> : <MenuIcon className="h-5 w-5" data-id="element-537" data-mp="330hz6t6h1752" />}
              </IconButton>
            </span>
          </div>
        </div>

        <AnimatePresence data-id="element-538" data-mp="3fc2cs1gr3dsh">
          {open && <motion.nav aria-label="Mobile" initial={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          y: -12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          y: -8,
          transition: {
            duration: 0.15
          }
        }} transition={spring.stable} className="border-t-3 border-line bg-paper px-5 pb-6 pt-3 md:hidden" data-id="element-539" data-mp="3fctvwct5vj1v">
              <motion.ul initial="hidden" animate="show" variants={{
            hidden: {},
            show: {
              transition: {
                staggerChildren: 0.05
              }
            }
          }} className="flex flex-col" data-id="element-540" data-mp="23phwnfwr35k">
                {[...links, {
              to: "/auth/signin",
              label: "Sign in"
            }].map(l => <motion.li key={l.to} variants={{
              hidden: {
                opacity: 0,
                y: 10
              },
              show: {
                opacity: 1,
                y: 0,
                transition: spring.smooth
              }
            }} data-id="element-541" data-mp="gsloeg2bg842">
                    <Link to={l.to} className="focus-ring block rounded-xl py-3 text-2xl font-bold tracking-[-0.01em]" data-id="element-542" data-mp="1iijx3qqaiae7">
                      {l.label}
                    </Link>
                  </motion.li>)}
              </motion.ul>
              <div className="mt-4" data-id="element-543" data-mp="1nco7kjyrl0k1">
                <BrutalButton to="/auth/signup" full size="lg" data-id="element-544" data-mp="1ndpp97aaclaq">
                  Start learning free
                </BrutalButton>
              </div>
            </motion.nav>}
        </AnimatePresence>
      </header>

      <main className="flex-1" data-id="element-545" data-mp="18mgxosmtopuy">
        <Outlet data-id="element-546" data-mp="18ni76so6x4ak" />
      </main>
      <SiteFooter data-id="element-547" data-mp="18km8h24iqbl2" />
    </div>;
}